import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@markant-platform/shared/data-access';

interface ErrorPageData {
  email?: string | null;
  subject?: string | null;
  companyName?: string | null;
  gln?: string | null;
  description?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorPageService {
  apiUrl: string = AppConfigService.appConfiguration.apiUrl['userServiceSupport'];
  basicAuthCredentials = AppConfigService.appConfiguration.basicAuthCredentials;

  constructor(private readonly http: HttpClient) {}

  submitSupportForm(data: ErrorPageData): Observable<void> {
    const headers = new HttpHeaders({
      Authorization: `Basic ${this.basicAuthCredentials}`,
    });

    return this.http.post<void>(this.apiUrl, data, { headers });
  }
}
